import React, { useEffect, useState } from "react";
import RangeSlider from "react-range-slider-input";
import { useDispatch } from "react-redux";
import { setFilters, clearFilters } from "./features/productSlice";
import PriceDisplay from "./PriceDisplay";
const FilterSection = () => {
  const dispatch = useDispatch();
  const [catList, setCatList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 2500]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);

  // Local state for filters
  const [localFilters, setLocalFilters] = useState({
    category: "",
    location: "",
    price: "",
  });

  const handleRangeChange = (values) => {
    setPriceRange(values);
    setLocalFilters((prev) => ({
      ...prev,
      price: `${values[0]}-${values[1]}`,
    }));
  };

  const fetchCategories = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/categories`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await res.json();
      setCatList(data.responseObject);
      // console.log("catlist", data.responseObject);
    } catch (error) {
      // console.log("fetch cat error", error.response);
    }
  };

  const fetchStates = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/states/active`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await res.json();
      // console.log(res)
      setStateList(data.responseObject);
    } catch (error) {
      // console.log("fetch cat error", error.response);
    }
  };
  const [settingList, setSettingList] = useState({
    min_price: "",
    max_price: "",
  });
  const fetchSettingList = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/web-setting-view`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // console.log("res", res)
      const data = await res.json();
      setSettingList(data.responseObject);
      const minPrice = Number(data.responseObject.min_price) || 0;
      const maxPrice = Number(data.responseObject.max_price) || 2500;
      setPriceRange([minPrice, maxPrice]);
    } catch (error) {
      // console.log("error fetch faq", error);
    }
  };

  useEffect(() => {
    fetchSettingList();
  }, []);

  const handleCategoryChange = (catId) => {
    setSelectedCategories((prev) => {
      if (prev.includes(catId)) {
        return prev.filter((id) => id !== catId);
      }
      return [...prev, catId];
    });
  };

  const handleStateChange = (stateName) => {
    setSelectedLocations((prev) => {
      if (prev.includes(stateName)) {
        return prev.filter((name) => name !== stateName);
      }
      return [...prev, stateName];
    });
  };

  const handleApplyFilters = () => {
    // Check if all categories are selected
    const isAllCategoriesSelected =
      selectedCategories.length ===
      catList.filter((cat) => cat.isAvailable).length;

    // Check if all states are selected
    const isAllStatesSelected = selectedLocations.length === stateList.length;

    // If all categories and states are selected, only apply price filter
    dispatch(
      setFilters({
        categories: isAllCategoriesSelected ? [] : selectedCategories,
        locations: isAllStatesSelected ? [] : selectedLocations,
        priceRange: priceRange,
      })
    );
  };

  const handleClearAll = () => {
    setSelectedCategories([]);
    setSelectedLocations([]);
    setPriceRange([
      Number(settingList.min_price) || 0,
      Number(settingList.max_price) || 2500,
    ]);
    dispatch(clearFilters());
  };
  useEffect(() => {
    fetchStates();
    fetchCategories();
    handleClearAll();
  }, []);
  return (
    <>
      <div className="col-lg-3 col-md-4">
        <div className="shop-bar sticky-lg-top">
          <div className="shop-bar-head">
            <h5>Filter</h5>
            <button type="button bg-none bg-0 " onClick={handleClearAll}>
              Clear All
            </button>
          </div>
          <div className="shop-bar-innr">
            <div className="accordion">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#filter-01"
                  >
                    Category
                  </button>
                </h2>
                <div
                  id="filter-01"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {catList.map(
                      (cat) =>
                        cat.isAvailable && (
                          <div key={cat._id} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`category-${cat._id}`}
                              checked={selectedCategories.includes(cat._id)}
                              onChange={() => handleCategoryChange(cat._id)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`category-${cat._id}`}
                            >
                              {cat.categoryName}
                            </label>
                          </div>
                        )
                    )}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#filter-02"
                  >
                    State
                  </button>
                </h2>
                <div id="filter-02" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    {stateList.map((sub) => {
                      return (
                        <div key={sub._id} className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedLocations.includes(sub.stateName)}
                            onChange={() => handleStateChange(sub.stateName)}
                            id={`sub-category-${sub._id}`}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`sub-category-${sub._id}`}
                          >
                            {sub.stateName}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#filter-03"
                  >
                    Price
                  </button>
                </h2>
                <div id="filter-03" className="accordion-collapse collapse">
                  <div className="accordion-body">
                    <div className="range-slide">
                      <RangeSlider
                        className="single-thumb w-100"
                        defaultValue={[
                          Number(settingList.min_price) || 0,
                          Number(settingList.max_price) || 2500,
                        ]}
                        thumbsDisabled={[true, false]}
                        rangeSlideDisabled={true}
                        name="points2"
                        value={priceRange}
                        onInput={handleRangeChange}
                        min={Number(settingList.min_price) || 0}
                        max={Number(settingList.max_price) || 2500}
                      />
                      <div className="slider-labels d-flex justify-content-between pt-3">
                        <span>{<PriceDisplay priceUSD={priceRange[0]} />}</span>
                        <span>{<PriceDisplay priceUSD={priceRange[1]} />}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-group mt-4">
              <button
                className="thm-btn w-100"
                onClick={handleApplyFilters}
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterSection;
